// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\components\\\\pages\\\\studios\\\\WelcomeSection\\\\WelcomeSection.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\components\\pages\\studios\\WelcomeSection\\WelcomeSection.tsx");
  import.meta.hot.lastModified = "1757171103351.3674";
}
// REMIX HMR END

import { HeroSection } from "../../home/WelcomeSection/components/HeroSection";
import { HeroActions } from "../../home/WelcomeSection/components/HeroActions";
export function WelcomeSection({
  data
}) {
  const heroActions = [{
    label: data.ctaLabel,
    href: data.ctaHref,
    variant: "fill-white",
    icon: true
  }];
  return <HeroSection backgroundImage={data.backgroundImage} title={data.title} subtitle={data.subtitle}>
      <HeroActions actions={heroActions} />
    </HeroSection>;
}
_c = WelcomeSection;
var _c;
$RefreshReg$(_c, "WelcomeSection");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;